import { FieldWrapper, Label, MultiSelect } from '@commenda/kakashi';
import { useState } from 'react';

interface Assignee {
  id: string;
  name: string;
  email: string;
}

interface Company {
  members?: {
    id: string;
    name: string;
    email: string;
  }[];
}

interface AddAssigneesStepProps {
  company?: Company;
  currentAssignees: Assignee[];
  onBack: () => void;
  onAssigneesSelected: (assigneeIds: string[]) => void;
  selectedAssignees: string[];
}

export const AddAssigneesStep = ({
  company,
  currentAssignees,
  onBack,
  onAssigneesSelected,
  selectedAssignees,
}: AddAssigneesStepProps) => {
  const [selectedAssigneeIds, setSelectedAssigneeIds] =
    useState<string[]>(selectedAssignees);

  const existingAssigneeIds = currentAssignees.map((assignee) => assignee.id);

  const availableMembers = (company?.members || [])
    .filter((member) => !existingAssigneeIds.includes(member.id))
    .map((member) => ({
      value: member.id,
      label: member.name,
    }));

  const handleValueChange = (value: string[]) => {
    setSelectedAssigneeIds(value);
    onAssigneesSelected(value);
  };

  const hasAvailableMembers = availableMembers.length > 0;

  return (
    <div className="flex flex-col gap-4xl p-3xl">
      <FieldWrapper>
        <Label htmlFor="assignees">Select team members *</Label>
        <MultiSelect
          id="assignees"
          options={availableMembers}
          placeholder="Select team members"
          onValueChange={handleValueChange}
          disabled={!hasAvailableMembers}
          defaultValue={selectedAssigneeIds}
        />
        {!hasAvailableMembers && (
          <p className="txt-small-medium text-text-tertiary mt-sm">
            No available team members to assign.
          </p>
        )}
      </FieldWrapper>
    </div>
  );
};
